/**
 * The identity of an analysis: which ETFs, with which weights.
 *
 * A saved analysis stays visible after the user edits the selection, but it must
 * be marked as no longer describing what is on screen. Comparing signatures is
 * how that is decided — order does not matter, weights are compared at 4
 * decimals like the backend stores them.
 */
export function selectionSignature(isins, weights) {
  return (isins || [])
    .filter(Boolean)
    .map((isin) => `${isin}:${Number(weights?.[isin] ?? 0).toFixed(4)}`)
    .sort()
    .join("|");
}

export function portfolioSignature(items) {
  return selectionSignature(
    (items || []).map((i) => i.isin),
    Object.fromEntries((items || []).map((i) => [i.isin, Number(i.weight_pct) || 0])),
  );
}

export default selectionSignature;
